var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { getXSRF } from "../../src/Services/Shared/FetchService";
export default function OAuthReceiver(props) {
    const [hasCookie, setHasCookie] = React.useState(false);
    const location = useLocation();
    const params = React.useMemo(() => new URLSearchParams(decodeURIComponent(location.hash.substr(1))), [location.hash]);
    const token = React.useMemo(() => params.get("access_token"), [params]);
    const from = params.get("state");
    const onTokenReceived = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        // Find how long this token is good for.
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        const expiresInSeconds = parseInt(params.get("expires_in"), 10);
        const tokenExpirationDate = new Date();
        tokenExpirationDate.setSeconds(tokenExpirationDate.getSeconds() + expiresInSeconds);
        yield fetch("/aviso/authToken/setAuthToken", {
            credentials: "include",
            method: "POST",
            headers: {
                "X-TOKEN": token || "",
                "X-XSRF-TOKEN": getXSRF(),
            },
        });
        setHasCookie(true);
        if (props.onTokenReceived) {
            props.onTokenReceived(token, tokenExpirationDate);
        }
    }), [params, props, token]);
    React.useEffect(() => {
        onTokenReceived();
    }, [onTokenReceived]);
    if (from) {
        if (hasCookie) {
            return _jsx(Redirect, { to: decodeURIComponent(from) });
        }
        return _jsx("div", { className: "d-none", children: "Authenticating..." });
    }
    if (!token) {
        return (_jsxs("div", { className: "alert alert-warning", children: [_jsx("span", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }), "Authentication error. Please try again."] }));
    }
    return (_jsxs("div", { className: "alert alert-success", children: [_jsx("span", { className: "fal fa-check-circle", "aria-hidden": "true" }), "Authentication successful! Please wait while we redirect you back to where you were trying to go."] }));
}
